import { render, staticRenderFns } from "./posts.vue?vue&type=template&id=66bab187&"
import script from "./posts.vue?vue&type=script&lang=js&"
export * from "./posts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports